import {Trans, useTranslation} from "react-i18next";
import {HashLink} from "react-router-hash-link";
import OpayInfoContactEmail from "../../trans/OpayInfoContactEmail.tsx";

const PricingShopifyBanner = () => {

    const {t} = useTranslation();

    return (
        <>
            <div className="pricing-shopify-banner">
                <p>
                    <Trans t={t} components={{
                        textOrange: <span className='text-orange'/>,
                        pricingForm: <HashLink className='text-orange' to={`/${t('routes.pricing')}#pricing-form`}/>,
                        contactEmail: OpayInfoContactEmail()
                    }}>
                        {'shopify_banner_text'}
                    </Trans>
                </p>
                <p>
                    <Trans t={t} components={{
                        textOrange: <span className='text-orange'/>,
                    }}>
                        {'attention_mobile_wallets'}
                    </Trans>
                </p>
            </div>
        </>
    )
}

export default PricingShopifyBanner;
